<template>
  <div class="cps-main-page">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item><i class="el-icon-s-home"></i>首页</el-breadcrumb-item>
      <el-breadcrumb-item>系统管理</el-breadcrumb-item>
      <el-breadcrumb-item>渠道号绑定管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-divider></el-divider>

    <div class="page-content">
    <el-row>
      <el-input v-model="queryField.admin_id" size="small" placeholder="管理员ID"></el-input>
      <el-input v-model="queryField.channel_code" style="width: 280px;" size="small" placeholder="渠道号"></el-input>
    
      <el-button v-if="showQuery" type="primary" @click="loadData(1)" icon="el-icon-search" size="small">查询</el-button>
      <el-button v-if="showAdd" type="primary" icon="el-icon-plus" size="small" @click="toThirdChannelAdd">新增</el-button>
    </el-row>
    <el-table class="cps-table-data"
            :data="tableData" size="small"
            border :height="height"
            style="width: 100%">
      <el-table-column
              prop="admin_id"
              label="管理员ID"
              width="100">
      </el-table-column>
      <el-table-column
              prop="channel_code"
              label="渠道号"
              width="280">
      </el-table-column>
      <el-table-column
              prop="add_time"
              label="新增时间"
              width="200">
      </el-table-column>
      <el-table-column
              label="操作">
          <template slot-scope="scope">
            <el-button v-if="showEdit" type="text" size="small" @click="editPage(scope.row)">编辑</el-button>
            <el-button type="text" size="small" @click="deleteRow(scope.row.id)">删除</el-button>
          </template>
      </el-table-column>
    </el-table>
    <el-pagination class="cps-table-data"
            @current-change="loadData"
            background
            :page-size="18"
            :current-page="currentIndex"
            layout="total, prev, pager, next"
            :total="total">
    </el-pagination>
    </div>
  </div>
</template>
<script>
  import { queryThirdpartyChannelList,deleteThirdpartyChannel,getPageButtons } from '@/api/request'
  export default {
    name: 'thirdChannelList',
    beforeRouteEnter(to, from, next) {
      next(vm=>{
        vm.refreshPage();
      });
    },
    data() {
      return {
        tableData: [],
        queryField: {
          admin_id: '',
          channel_code: ''
        },
        total: 0,
        currentIndex: 1,
        height: window.innerHeight - 210,
        showQuery: false,
        showAdd: false,
        showEdit: false
      }
    },
    mounted() {
      this.loadData(1);
      this.getPageButtons();
    },
    methods: {
      refreshPage() {
        this.loadData(1);
      },
      getPageButtons() {
        let path = this.$route.path.replace("/", "");
        getPageButtons(path).then(res => {
          if (res.data.success) {
            let menuCodes = res.data.data;
            this.showQuery = menuCodes.includes("thirdparty_channel_query");
            this.showAdd = menuCodes.includes("thirdparty_channel_add");
            this.showEdit = menuCodes.includes("thirdparty_channel_edit");
          } else {
          }
        });
      },
      loadData(index) {
        let params = {
          pageNo: index,
          pageSize: 18,
          params : this.queryField,
        }
        queryThirdpartyChannelList(params).then(res => {
          this.tableData = res.data.list;
          this.total = res.data.total;
          this.currentIndex = index;
        })

      },
      editPage(row) {
        console.log('row',row)
        this.$router.push({ name: 'ThirdChannelEdit' ,params:{id:row.id,admin_id:row.admin_id,channel_code:row.channel_code} });
      },
      toThirdChannelAdd(){
        this.$router.push({ path: '/thirdChannelList/thirdChannelAdd' });
      },
      deleteRow(id) {
        deleteThirdpartyChannel({id:id}).then(res => {
          if (res.data.success){
            this.$message.success('删除成功');
            this.loadData(this.currentIndex);
          }
          else {
            this.$message.error(res.data.error.message);
          }
        })
      },
      formatIsChild(row, column, cellValue) {
        if (cellValue) {
          return '是'
        } else {
          return '否'
        }
      }
    },
  }
</script>

<style lang="scss" scoped>
  .cps-main-page{
    .cps-table-data{
      td {
        .el-image {
          display: inherit;
        }
      }
    }
  }
</style>
